var intro = 'なし';
var intro_price = '料率（5%）';
var road_occu = '不要';
var constructor = 'ハウスメーカー';
var ug = 0;
var ug_wall = 'なし';
var diff_height = 'なし';
var chimney = 'なし';
var asbestos = '該当しない';

jQuery(function($){

  $('input[type="text"]').focus(function(){
    $(this).select();
  });

  intro = $('.js-radio-intro:checked').val();
  intro_price = $('.js-radio-intro-price:checked').val();
  road_occu = $('.js-radio-road-occu:checked').val();
  constructor = $('.js-radio-const:checked').val();
  ug = $('.js-ug').val();
  ug_wall = $('.js-radio-ug-wall:checked').val();
  diff_height = $('.js-radio-diff-height:checked').val();
  chimney = $('.js-radio-chimney:checked').val();
  asbestos = $('.js-radio-asbestos:checked').val();
  
  toggle_intro(intro);
  toggle_intro_price(intro_price);
  toggle_road_occu(road_occu);
  toggle_constructor(constructor);
  toggle_ug(ug);
  toggle_ug_wall(ug_wall);
  toggle_diff_height(diff_height);
  toggle_chimney(chimney);
  toggle_asbestos(asbestos);

  $('.js-radio-intro').on('change', function(){
    var val = $(this).val();
    toggle_intro(val);
  });

  $('.js-radio-intro-price').on('change', function(){
    var val = $(this).val();
    toggle_intro_price(val);
  });

  $('.js-radio-road-occu').on('change', function(){
    var val = $(this).val();
    toggle_road_occu(val);
  });

  $('.js-radio-const').on('change', function(){
    var val = $(this).val();
    toggle_constructor(val);
  });

  $('.js-ug').on('change', function(){
    var val = $(this).val();
    toggle_ug(val);
  });

  $('.js-radio-ug-wall').on('change', function(){
    var val = $(this).val();
    toggle_ug_wall(val);
  });

  $('.js-radio-diff-height').on('change', function(){
    var val = $(this).val();
    toggle_diff_height(val);
  });

  $('.js-radio-chimney').on('change', function(){
    var val = $(this).val();
    toggle_chimney(val);
  });

  $('.js-radio-asbestos').on('change', function(){
    var val = $(this).val();
    toggle_asbestos(val);
  });

});

function toggle_intro(val) {
  if(val == 'あり') {
    $('#box_intro').removeClass('hide');
  }else if(val == 'なし') {
    $('#box_intro').addClass('hide');
  }
}

function toggle_intro_price(val) {
  if(val == '固定額') {
    $('#box_rate_price').addClass('hide');
    $('#box_fixed_price').removeClass('hide');
  }else if(val == '料率（5%）') {
    $('#box_rate_price').removeClass('hide');
    $('#box_fixed_price').addClass('hide');
  }
}

function toggle_road_occu(val) {
  if(val != '不要') {
    $('#box_road_occu').removeClass('hide');
  }else if(val == '不要') {
    $('#box_road_occu').addClass('hide');
  }
}

function toggle_constructor(val) {
  if(val == 'その他') {
    $('#box_const').removeClass('hide');
  }else if(val != 'その他') {
    $('#box_const').addClass('hide');
  }
}

function toggle_ug(val) {
  if(val == 0) {
    $('#box_ug').addClass('hide');
  }else if(val > 0) {
    $('#box_ug').removeClass('hide');
  }
}

function toggle_ug_wall(val) {
  if(val == 'なし') {
    $('#box_ug_wall').addClass('hide');
  }else if(val == 'あり') {
    $('#box_ug_wall').removeClass('hide');
  }
}

function toggle_diff_height(val) {
  if(val == 'なし') {
    $('#box_diff_height').addClass('hide');
  }else if(val != 'なし') {
    $('#box_diff_height').removeClass('hide');
  }
}

function toggle_chimney(val) {
  if(val == 'なし') {
    $('#box_chimney').addClass('hide');
  }else if(val == 'あり') {
    $('#box_chimney').removeClass('hide');
  }
}

function toggle_asbestos(val) {
  if(val == '該当しない') {
    $('#box_asbestos').addClass('hide');
  }else if(val == '該当する') {
    $('#box_asbestos').removeClass('hide');
  }
}